import { render } from "./Backdrop.vue?vue&type=template&id=08ec2292&scoped=true&ts=true"
import script from "./Backdrop.vue?vue&type=script&lang=ts"
export * from "./Backdrop.vue?vue&type=script&lang=ts"

import "../../assets/scss/ui/backdrop.scss?vue&type=style&index=0&id=08ec2292&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ec2292"]])

export default __exports__